import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { CarriersAvailabilitySummaryResponse } from '@types'
import { OtherUtils } from '@utils'

import { getCarriersAvailabilitySummary } from '../api'

const useGetCarriersAvailabilitySummary = (date?: string) => {
  const { data, isLoading, refetch } = useQuery<CarriersAvailabilitySummaryResponse>(
    [QUERY_KEYS.CARRIERS_AVAILABILITY_SUMMARY],
    () => getCarriersAvailabilitySummary(date!),
    {
      onError: OtherUtils.onErrorHandler,
      staleTime: Infinity,
      enabled: !!date,
    },
  )

  return {
    refetchCarriersAvailabilitySummaryData: refetch,
    carriersAvailabilitySummaryData: data,
    carriersAvailabilitySummaryDataIsLoading: isLoading,
  }
}

export { useGetCarriersAvailabilitySummary }
